<template>
    <div class="box">
        <contentbox @close="close">
            <template slot="content">
                <!-- 公共属性部分-基本信息-开始 -->
                <div class="list">
                    <div class="titleBox">
                        <div class="title">基本信息</div>
                        <div class="closeAlarmBox" v-if="deviceData.alarmStatus" @click="clearAlert()"
                            style="margin-left: 20px;">
                            解除报警</div>
                    </div>
                    <table>
                        <tbody>
                            <tr class="even-row">
                                <td>设备名称</td>
                                <td>设备别名</td>
                                <td>维护状态</td>
                                <td>创建时间</td>
                                <td>更新时间</td>
                            </tr>
                            <tr>
                                <td>{{ deviceData.deviceName }}</td>
                                <td class="point" @click="setting('anotherName')">
                                    {{ deviceData.anotherName ? deviceData.anotherName : '未设置' }}
                                </td>
                                <td>{{ deviceData.maintain == '1' ? '维护' : '正常' }}</td>
                                <td>{{ deviceData.createtime }}</td>
                                <td>{{ deviceData.updatetime }}</td>
                            </tr>
                            <tr class="even-row">
                                <td>经度</td>
                                <td>纬度</td>
                                <td>设备图片</td>
                                <td>设备类型</td>
                                <td>设备位置</td>
                            </tr>
                            <tr>
                                <td class="point">{{ deviceData.latitude ? deviceData.latitude : '未设置' }}</td>
                                <td class="point">{{ deviceData.longitude ? deviceData.longitude : '未设置' }}</td>
                                <td class="point" @click="showImg">查看</td>
                                <td>{{ deviceData.deviceType }}</td>
                                <td>
                                    {{ deviceData.county + deviceData.address ? deviceData.county + deviceData.address :
                                        '未设置' }}
                                </td>
                            </tr>
                            <tr v-if="deviceData.imsih" class="even-row">
                                <td>sim卡信息</td>
                                <td>项目ID</td>
                            </tr>
                            <tr v-if="deviceData.imsih">
                                <td class="point" @click="openSim">查看</td>
                                <td>{{ deviceData.projectId }}</td>

                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- 公共属性部分-基本信息-结束 -->

                <!-- sim卡信息开始 -->
                <div class="list" v-if="deviceData.imsih && simShow">
                    <div class="title">SIM卡信息</div>
                    <table>
                        <tbody>
                            <tr class="even-row">
                                <td>MSISDN</td>
                                <td>ICCID</td>
                                <td>IMSI</td>
                                <td>运行商</td>
                            </tr>
                            <tr>
                                <td>{{ simData.msisdn }}</td>
                                <td>{{ simData.iccid }}</td>
                                <td>{{ simData.imsi }}</td>
                                <td>{{ simData.carrier }}</td>
                            </tr>
                            <tr class="even-row">
                                <td>套餐大小</td>
                                <td>计费结束日期</td>
                                <td>当月流量</td>
                                <td>剩余流量</td>
                            </tr>
                            <tr>
                                <td>{{ simData.data_plan + ' M' }}</td>
                                <td>{{ simData.expiry_date }}</td>
                                <td>{{ simData.data_usage + ' M' }}</td>
                                <td>{{ simData.data_balance + ' M' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- sim卡信息结束 -->

                <!-- 设备属性开始  -->
                <div class="list" v-if="deviceData.deviceType == '水位流速监测'">
                    <div class="title">设备属性</div>
                    <table>
                        <tbody>
                            <tr class="even-row">
                                <td>报警状态</td>
                                <td>软件版本</td>
                                <td>管网报警水位</td>
                                <td>检查井筒报警水位</td>
                                <td>瞬时流量报警阈值</td>
                            </tr>
                            <tr>
                                <td>{{ deviceData.alarmStatus ? '报警' : '正常' }}</td>
                                <td>{{ deviceData.software }}</td>
                                <td class="point">{{ deviceData.alarmLevel1 ? deviceData.alarmLevel1 : '未设置' }}</td>
                                <td class="point">{{ deviceData.alarmLevel2 ? deviceData.alarmLevel2 : '未设置' }}</td>
                                <td class="point">{{ deviceData.alarmFlow ? deviceData.alarmFlow : '未设置' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="list" v-if="deviceData.deviceType == '雨量监测'">
                    <div class="title">设备属性</div>
                    <table>
                        <tbody>
                            <tr class="even-row">
                                <td>报警状态</td>
                                <td>软件版本</td>
                                <td>报警瞬时雨量</td>
                            </tr>
                            <tr>
                                <td>{{ deviceData.alarmStatus ? '报警' : '正常' }}</td>
                                <td>{{ deviceData.software }}</td>
                                <td class="point">{{ deviceData.alarmRain ? deviceData.alarmRain : '未设置' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="list" v-if="deviceData.deviceType == '智能井盖'">
                    <div class="title">设备属性</div>

                    <table v-if="deviceData.projectId == 'SDlwV4'">
                        <tbody>
                            <tr class="even-row">
                                <td>报警状态</td>
                                <td>心跳周期</td>
                                <td>软件版本</td>
                                <td>安全角度阈值</td>
                                <td>告警角度阈值</td>
                            </tr>
                            <tr>
                                <td>{{ deviceData.alarmStatus ? '报警' : '正常' }}</td>
                                <td>{{ deviceData.HB }} s</td>
                                <td>v4</td>
                                <td>{{ deviceData.ST }} °</td>
                                <td>{{ deviceData.TT }} °</td>
                            </tr>
                        </tbody>
                    </table>
                    <table v-else-if="deviceData.projectId == 'SDbsjS'">
                        <tbody>
                            <tr class="even-row">
                                <td>报警状态</td>
                                <!-- <td>小区ID</td> -->
                                <td>心跳周期</td>
                                <td>软件版本</td>
                                <td>角度预警阈值</td>
                                <td>电压预警阈值</td>
                                <td>震动预警阈值</td>
                                <td>满溢预警阈值</td>
                                <td>颠簸预警阈值</td>
                                <td>建准值</td>
                            </tr>
                            <tr>
                                <td>{{ deviceData.alarmStatus ? '报警' : '正常' }}</td>
                                <td>{{ deviceData.heartbeatTime }} min</td>
                                <td>{{ deviceData.software }}</td>
                                <td>{{ deviceData.limit_qj }} °</td>
                                <td>{{ deviceData.limit_dy }}</td>
                                <td>{{ deviceData.limit_zd }}</td>
                                <td>{{ deviceData.limit_my }}</td>
                                <td>{{ deviceData.limit_db }}</td>
                                <td>{{ deviceData.limit_jz }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table v-else>
                        <tbody>
                            <tr class="even-row">
                                <td>报警状态</td>
                                <td>心跳周期</td>
                                <td>软件版本</td>
                                <td>角度预警阈值</td>
                                <td>安装角度补偿</td>
                            </tr>
                            <tr>
                                <td>{{ deviceData.alarmStatus ? '报警' : '正常' }}</td>
                                <td>{{ deviceData.heartbeatTime ? deviceData.heartbeatTime : 720 }} min</td>
                                <td>{{ deviceData.software ? deviceData.software : 'v1.0' }}</td>
                                <td>{{ deviceData.tiltAlarmTH ? deviceData.tiltAlarmTH : 25 }} °</td>
                                <td>{{ 0 }} °</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="list" v-if="deviceData.deviceType == '智能井盖V4'">
                    <div class="title">设备属性</div>
                    <table>
                        <tbody>
                            <tr class="even-row">
                                <td>报警状态</td>
                                <td>心跳周期</td>
                                <td>软件版本</td>
                                <td>安全角度阈值</td>
                                <td>告警角度阈值</td>
                            </tr>
                            <tr>
                                <td>{{ deviceData.alarmStatus ? '报警' : '正常' }}</td>
                                <td>{{ deviceData.HB }} s</td>
                                <td>v4</td>
                                <td>{{ deviceData.ST }} °</td>
                                <td>{{ deviceData.TT }} °</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="list" v-if="deviceData.deviceType == '智能井盖4G'">
                    <div class="title">设备属性</div>
                    <table>
                        <tbody>
                            <tr class="even-row">
                                <td>报警状态</td>
                                <!-- <td>小区ID</td> -->
                                <td>心跳周期</td>
                                <td>软件版本</td>
                                <td>角度预警阈值</td>
                                <td>电压预警阈值</td>
                                <td>震动预警阈值</td>
                                <td>满溢预警阈值</td>
                                <td>颠簸预警阈值</td>
                                <td>建准值</td>
                            </tr>
                            <tr>
                                <td>{{ deviceData.alarmStatus ? '报警' : '正常' }}</td>
                                <td>{{ deviceData.heartbeatTime }} min</td>
                                <td>{{ deviceData.software }}</td>
                                <td>{{ deviceData.limit_qj }} °</td>
                                <td>{{ deviceData.limit_dy }}</td>
                                <td>{{ deviceData.limit_zd }}</td>
                                <td>{{ deviceData.limit_my }}</td>
                                <td>{{ deviceData.limit_db }}</td>
                                <td>{{ deviceData.limit_jz }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="list" v-if="deviceData.deviceType == '积水监测'">
                    <div class="title">设备属性</div>
                    <table>
                        <tbody>
                            <tr class="even-row">
                                <td>报警状态</td>
                                <td>电压</td>
                                <td>信号强度</td>
                            </tr>
                            <tr>
                                <td>{{ deviceData.alarmStatus ? '报警' : '正常' }}</td>
                                <td>{{ deviceData.BatteryRemain }} v</td>
                                <td>{{ deviceData.signal }} dbm</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="list" v-if="deviceData.deviceType == '雷达水位计'">
                    <div class="title">设备属性</div>
                    <table>
                        <tbody>
                            <tr class="even-row">
                                <td>报警状态</td>
                                <td>软件版本</td>
                            </tr>
                            <tr>
                                <td>{{ deviceData.alarmStatus ? '报警' : '正常' }}</td>
                                <td>{{ deviceData.software }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="list" v-if="deviceData.deviceType == '不锈钢井盖'">
                    <div class="title">设备属性</div>
                    <table>
                        <tbody>
                            <tr class="even-row">
                                <td>CCID</td>
                                <td>报警状态</td>
                                <td>软件版本</td>
                            </tr>
                            <tr>
                                <td>{{ deviceData.CCID }} </td>
                                <td>{{ deviceData.alarmStatus ? '报警' : '正常' }}</td>
                                <td>{{ deviceData.software }}</td>

                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="list" v-if="deviceData.deviceType == '水质监测'">
                    <div class="title">设备属性</div>
                    <table>
                        <tbody>
                            <tr class="even-row">
                                <td>报警状态</td>
                                <td>在线状态</td>
                                <td>软件版本</td>
                                <td>PH最大阈值</td>
                                <td>PH最小阈值</td>
                                <td>水位阈值</td>
                                <td v-if="!hasCOD">COD阈值</td>
                                <td>EC阈值</td>
                                <td>井深</td>
                                <td>支架长度</td>
                            </tr>
                            <tr>
                                <td>{{ deviceData.alarmStatus ? '报警' : '正常' }}</td>
                                <td>{{ deviceData.isLine ? '在线' : '离线' }}
                                </td>
                                <td>{{ deviceData.software }}</td>
                                <td>{{ deviceData.phLimitMax ? deviceData.phLimitMax : '未设置' }}</td>
                                <td>{{ deviceData.phLimitMin ? deviceData.phLimitMin : '未设置' }}</td>
                                <td>{{ deviceData.waterLimit ? deviceData.waterLimit : '未设置' }}</td>
                                <td v-if="!hasCOD">{{ deviceData.codLimit ? deviceData.codLimit : '未设置' }}</td>
                                <td>{{ deviceData.ecLimit ? deviceData.ecLimit : '未设置' }}</td>
                                <td>{{ deviceData.deep ? deviceData.deep : '未设置' }}</td>
                                <td>{{ deviceData.tie ? deviceData.tie : '未设置' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- 设备属性结束  -->

                <!-- 监测数据开始 -->
                <div class="list" v-if="deviceData.deviceType == '水位流速监测'">
                    <div class="title">监测数据</div>
                    <table>
                        <tbody>
                            <tr class="even-row">
                                <td>瞬时流量</td>
                                <td>管网水位</td>
                                <td>检查井筒水位</td>
                                <td>断面流速</td>
                                <td>累计流量</td>
                            </tr>
                            <tr>
                                <td>{{ deviceData.flow }} m³/s</td>
                                <td>{{ deviceData.level1 }} m</td>
                                <td>{{ deviceData.level2 }} m</td>
                                <td>{{ deviceData.section_speed }} m/s</td>
                                <td>{{ deviceData.total_flow }} m³</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="list" v-if="deviceData.deviceType == '雨量监测'">
                    <div class="title">监测数据</div>
                    <table>
                        <tbody>
                            <tr class="even-row">
                                <td>累计雨量</td>
                                <td>昨日雨量</td>
                                <td>今日雨量</td>
                                <td>瞬时雨量</td>
                            </tr>
                            <tr>
                                <td>{{ deviceData.allRain }} mm</td>
                                <td>{{ deviceData.yesterdayRain }} mm</td>
                                <td>{{ deviceData.todayRain }} mm</td>
                                <td>{{ deviceData.momentRain }} mm</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="list" v-if="deviceData.deviceType == '智能井盖'">
                    <div class="title">监测数据</div>
                    <table v-if="deviceData.projectId == 'SDlwV4'">
                        <tbody>
                            <tr class="even-row">
                                <td>开启状态</td>
                                <td>井盖倾斜度</td>
                                <td>电池电压</td>
                                <td>信号强度</td>
                            </tr>
                            <tr>
                                <td>{{ deviceData.CS ? '打开' : '关闭' }}</td>
                                <td>{{ deviceData.TV }} °</td>
                                <td>{{ deviceData.BR }} V</td>
                                <td>{{ deviceData.R }} dbm</td>
                            </tr>
                        </tbody>
                    </table>
                    <table v-else-if="deviceData.projectId == 'SDbsjS'">
                        <tbody>
                            <tr class="even-row">
                                <td>开启状态</td>
                                <td>井盖倾斜度</td>
                                <td>电池电压</td>
                                <td>信号强度</td>
                                <!-- <td>参考信号接收功率</td>
                                <td>信号与干扰加噪声比</td> -->
                            </tr>
                            <tr>
                                <td>{{ deviceData.openStatus ? '打开' : '关闭' }}</td>
                                <td>{{ deviceData.TiltValue }} °</td>
                                <td>{{ deviceData.BatteryRemain }} V</td>
                                <td>{{ deviceData.csqSignal }} dbm</td>
                                <!-- <td>{{ deviceData.rsrp }} dbm</td>
                                <td>{{ deviceData.sinr }} db</td> -->
                            </tr>
                        </tbody>
                    </table>
                    <table v-else>
                        <tbody>
                            <tr class="even-row">
                                <td>开启状态</td>
                                <td>井盖倾斜度</td>
                                <td>井内光照度</td>
                                <td>电池电压</td>
                                <td>信号强度</td>
                                <td>参考信号接收功率</td>
                                <td>信号与干扰加噪声比</td>
                            </tr>
                            <tr>
                                <td>{{ deviceData.openStatus ? '打开' : '关闭' }}</td>
                                <td>{{ deviceData.TiltValue }} °</td>
                                <td>{{ deviceData.light }} lux</td>
                                <td>{{ deviceData.BatteryRemain }} V</td>
                                <td>{{ deviceData.rssi }} dbm</td>
                                <td>{{ deviceData.rsrp }} dbm</td>
                                <td>{{ deviceData.sinr }} db</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="list" v-if="deviceData.deviceType == '智能井盖4G'">
                    <div class="title">监测数据</div>
                    <table>
                        <tbody>
                            <tr class="even-row">
                                <td>开启状态</td>
                                <td>井盖倾斜度</td>
                                <td>电池电压</td>
                                <td>信号强度</td>
                                <!-- <td>参考信号接收功率</td>
                                <td>信号与干扰加噪声比</td> -->
                            </tr>
                            <tr>
                                <td>{{ deviceData.openStatus ? '打开' : '关闭' }}</td>
                                <td>{{ deviceData.TiltValue }} °</td>
                                <td>{{ deviceData.BatteryRemain }} V</td>
                                <td>{{ deviceData.csqSignal }} dbm</td>
                                <!-- <td>{{ deviceData.rsrp }} dbm</td>
                                <td>{{ deviceData.sinr }} db</td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="list" v-if="deviceData.deviceType == '智能井盖V4'">
                    <div class="title">监测数据</div>
                    <table>
                        <tbody>
                            <tr class="even-row">
                                <td>开启状态</td>
                                <td>井盖倾斜度</td>
                                <td>电池电压</td>
                                <td>信号强度</td>
                            </tr>
                            <tr>
                                <td>{{ deviceData.CS ? '打开' : '关闭' }}</td>
                                <td>{{ deviceData.TV }} °</td>
                                <td>{{ deviceData.BR }} V</td>
                                <td>{{ deviceData.R }} dbm</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="list" v-if="deviceData.deviceType == '积水监测'">
                    <div class="title">监测数据</div>
                    <table>
                        <tbody>
                            <tr class="even-row">
                                <td>水位</td>
                                <!-- <td>参考信号接收功率</td>
                                <td>信号与干扰加噪声比</td> -->
                            </tr>
                            <tr>
                                <td>{{ deviceData.waterLevel }} m</td>
                                <!-- <td>{{ deviceData.rsrp }} dbm</td>
                                <td>{{ deviceData.sinr }} db</td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="list" v-if="deviceData.deviceType == '雷达水位计'">
                    <div class="title">监测数据</div>
                    <table>
                        <tbody>
                            <tr class="even-row">
                                <td>水位</td>
                            </tr>
                            <tr>
                                <td>{{ deviceData.waterLevel }} m</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="list" v-if="deviceData.deviceType == '不锈钢井盖'">
                    <div class="title">监测数据</div>
                    <table>
                        <tbody>
                            <tr class="even-row">
                                <td>锁机状态</td>
                                <td>井盖状态</td>
                                <td>信号强度</td>
                                <td>电池电压</td>
                            </tr>
                            <tr>

                                <td>{{ deviceData.openLock === 1 ? "开锁" : "关锁" }}</td>
                                <td>{{ deviceData.coverSta ? '开启' : '关闭' }}</td>
                                <td>{{ deviceData.signal }}dbm</td>
                                <td>{{ deviceData.ADC0 }}V</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="list" v-if="deviceData.deviceType == '智能井盖L3W'">
                    <div class="title">监测数据</div>
                    <table>
                        <tbody>
                            <tr class="even-row">
                                <td>开启状态</td>
                                <td>井盖倾斜度</td>
                                <td>井内光照度</td>
                                <td>水浸状态</td>
                                <td>电池电压</td>
                                <td>信号强度</td>
                                <td>参考信号接收功率</td>
                                <td>信号与干扰加噪声比</td>
                            </tr>
                            <tr>
                                <td>{{ deviceData.openStatus ? '打开' : '关闭' }}</td>
                                <td>{{ deviceData.TiltValue }} °</td>
                                <td>{{ deviceData.light }} lux</td>
                                <td>{{ deviceData.flood_monitoring ? '是' : '否' }}</td>
                                <td>{{ deviceData.BatteryRemain }} V</td>
                                <td>{{ deviceData.rssi }} dbm</td>
                                <td>{{ deviceData.rsrp }} dbm</td>
                                <td>{{ deviceData.sinr }} db</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="list" v-if="deviceData.deviceType == '水质监测'">
                    <div class="title">监测数据</div>
                    <table>
                        <tbody>
                            <tr class="even-row">
                                <td>PH值</td>
                                <td>测量水位值</td>
                                <td>标准水位值(井深-管长+测量水位+标高)</td>
                                <td v-if="!hasCOD">COD值</td>
                                <td>EC值</td>

                            </tr>
                            <tr>
                                <td>{{ deviceData.phValue }}</td>
                                <td>{{ deviceData.waterValue }} m</td>
                                <td>{{ deviceData.sWaterValue ? deviceData.sWaterValue : '未计算' }} m</td>
                                <td v-if="!hasCOD">{{ deviceData.codValue }} mg/L</td>
                                <td>{{ deviceData.ecValue }} uS/cm</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- 监测数据结束 -->

                <!-- 历史属性 -->
                <div class="list">
                    <div class="title proptyTitleBox">
                        <div>历史属性</div>
                        <div class="menu" @click="changeEchartsType">
                            <span>{{ isMoreEcharts ? '多属性' : '单属性' }}</span><span class="iconfont icon-qiehuan"></span>
                        </div>
                        <div class="menu" @click="exprotFile"><span>导出文件</span><span
                                class="iconfont icon-gongdan"></span>
                        </div>
                    </div>

                    <!-- 单属性图表开始 -->
                    <div class="echatsMenu">
                        <msSelect class="propt" @handleChange="selectChange" :selectOption="selectOption"
                            :defaultValue="selectDefaultValue" v-if="!isMoreEcharts"></msSelect>
                        <msDateTimeSelect class="date" @getDate="handleDateTimeUpdated"></msDateTimeSelect>
                        <div class="queryBtn" @click="queryHistoryPropty(isMoreEcharts, true)">查询</div>
                    </div>
                    <div class="echart" v-if="!isMoreEcharts" ref="canva7"></div>
                    <!-- 单属性图表结束 -->

                    <!-- 多属性图表开始 -->
                    <div v-if="isMoreEcharts" class="echart" ref="canva8"></div>
                    <!-- 多属性图表结束 -->
                </div>

                <div v-if="deviceData.deviceType == '水质监测'" class="list" style="width: 100%;">
                    <div style="display: flex;justify-content: space-between;">
                        <div class="history">
                            <div class="title">历史报警信息</div>
                            <div class="menu" @click="exprotFileAlarm"><span>导出文件</span><span
                                    class="iconfont icon-gongdan"></span>
                            </div>
                        </div>

                        <div class="echatsMenu">
                            <!-- <msSelect class="propt" @handleChange="selectChange" :selectOption="selectOption"
                                :defaultValue="selectDefaultValue" v-if="!isMoreEcharts"></msSelect> -->
                            <msDateTimeSelectTwo class="date" @getAlarmData="handleDateTimeUpdatedTwo">
                            </msDateTimeSelectTwo>
                            <div class="queryBtn" @click="getAlarmData(true)">查询</div>
                        </div>

                    </div>

                    <el-table :data="tableDatas" border fit highlight-current-row style="width: 100%;" stripe>
                        <el-table-column prop="time" label="报警时间" width="320" align="center"></el-table-column>
                        <el-table-column prop="type" label="报警类型" width="320" align="center"></el-table-column>
                        <el-table-column prop="sensorValue" label="异常数据" width="320" align="center"></el-table-column>
                    </el-table>
                </div>
            </template>
        </contentbox>

        <el-image-viewer v-if="showImgPriver" :on-close="hidImgPriverFunc" :url-list="[deviceData.imgSrc]" />
    </div>
</template>

<script>
import { QueryHistoryEventProject, closeAlerm, QueryHistoryProptyProject, QueryHistoryMoreProptyProject, QuerySim } from '@/api';
import contentbox from '@/components/common/maxWeb/contentbox.vue';
import msSelect from '@/components/common/msSelect.vue';
import msDateTimeSelect from '@/components/common/msDateTimeSelect.vue';
import msDateTimeSelectTwo from '@/components/common/msDateTimeSelectTwo.vue';

import moment from 'moment';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import json2Excel from '@/utils/json2Excel.js';

export default {
    props: {
        deviceData: Object
    },
    data() {
        return {
            simShow: false,
            simData: {},
            showImgPriver: false,
            echartsDom: null,
            selectOption: null, // 单属性图表属性选择器
            selectDefaultValue: null, // 单属性图表默认选择器件
            historyProptySearchTag: null, // 历史查询属性值
            historySelectDate: [new Date().getTime() - 3600 * 1000 * 24 * 1, new Date().getTime()], //历史查询时间
            alarmHistorySelectDate: [new Date().getTime() - 3600 * 1000 * 24 * 1, new Date().getTime()], //历史报警查询时间
            tableDatas: [],//报警历史数据
            isMoreEcharts: false, // 默认展示图表
            excData: {}, // 监测数据
            excData2: [], // 报警数据
            hasCOD: false,
        };
    },
    components: {
        contentbox,
        msSelect,
        msDateTimeSelect,
        msDateTimeSelectTwo,
        ElImageViewer
    },
    created() {
        this.settingSelectOption();
    },
    mounted() {
        if (this.deviceData.deviceNo == '03A0572AE0N7S40S' || this.deviceData.deviceNo == '74580F5E532252FK' || this.deviceData.deviceNo == '79A632Q1R5U20980' || this.deviceData.deviceNo == '74AP5916045Z8VSP' || this.deviceData.deviceNo == 'KEPF6F04B2E110HZ' || this.deviceData.deviceNo == '6VX5H9D513415CM5') {
            this.hasCOD = true
        }
        console.log(this.deviceData, 'this.deviceDatathis.deviceDatathis.deviceData');

        this.deviceData.createtime = moment(this.deviceData.createTime * 1).format('YYYY-MM-DD HH:mm:ss');
        this.deviceData.updatetime = moment(this.deviceData.updateTime * 1).format('YYYY-MM-DD HH:mm:ss');
        // this.echatsInit();
        // this.queryHistoryPropty();
        this.changeEchartsType();
        this.getAlarmData(false)
    },
    methods: {
        async getAlarmData(isClick) {
            let startTime = null
            let endTime = null
            if (isClick) {
                startTime = new Date(this.alarmHistorySelectDate[0] + ' ' + '00:00:00').getTime();
                endTime = new Date(this.alarmHistorySelectDate[1] + ' ' + '23:59:59').getTime();
            } else {
                startTime = new Date(this.alarmHistorySelectDate[0]).getTime();
                endTime = new Date(this.alarmHistorySelectDate[1]).getTime();
            }

            const result = await QueryHistoryEventProject({
                projectId: this.deviceData.projectId,
                deviceName: this.deviceData.deviceName,
                dateSelectValue: '3',
                startTime: startTime,
                endTime: endTime,
            });
            if (result.code !== 200) {
                return;
            }
            let dataArr = [];
            result.data.forEach((item) => {
                let obj = {};
                obj.time = moment(item.createTime * 1).format('MM-DD HH:mm:ss');
                let contentValue = {};
                switch (item.type) {
                    case '1':
                        obj.type = 'PH超限报警';
                        for (const key in item) {
                            if (item[key] !== null) {
                                contentValue[key] = item[key];
                            }
                        }
                        obj.content = JSON.stringify(contentValue);
                        dataArr.push(obj);
                        break;

                    case '2':
                        obj.type = '液位超限报警';
                        for (const key in item) {
                            if (item[key] !== null) {
                                contentValue[key] = item[key];
                            }
                        }
                        obj.content = JSON.stringify(contentValue);
                        dataArr.push(obj);
                        break;
                    case '3':
                        obj.type = 'COD超限报警';
                        for (const key in item) {
                            if (item[key] !== null) {
                                contentValue[key] = item[key];
                            }
                        }
                        obj.content = JSON.stringify(contentValue);
                        dataArr.push(obj);
                        break;
                    case '4':
                        obj.type = 'EC超限报警';
                        for (const key in item) {
                            if (item[key] !== null) {
                                contentValue[key] = item[key];
                            }
                        }
                        obj.content = JSON.stringify(contentValue);
                        dataArr.push(obj);
                        break;
                    default:
                        break;
                }
                obj.sensorValue = item.sensorValue

            });
            this.tableDatas = dataArr;
            this.excData2 = dataArr

            console.log(this.tableDatas, this.excData2, 'this.tableDatas');


        },

        //解除报警
        clearAlert() {
            console.log();
            this.$confirm('确定解除警报？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                closeAlerm({
                    deviceName: this.deviceData.deviceName,
                    projectId: this.deviceData.projectId,
                    deviceType: this.deviceData.deviceType
                });
                this.deviceData.alarmStatus = 0
                switch (this.deviceData.deviceType) {
                    case '智能井盖':
                        this.deviceData.openStatus = false
                        this.deviceData.TiltValue = 2
                        break;
                    case '智能井盖V2':
                        this.deviceData.openStatus = false
                        this.deviceData.TiltValue = 2
                        break;
                    case '智能井盖V4':
                        this.deviceData.CS = false
                        this.deviceData.TV = 2
                        break;
                    case '智能井盖4G':
                        this.deviceData.openStatus = false
                        this.deviceData.TiltValue = 2
                        break;
                    case '智能井盖L3W':
                        this.deviceData.openStatus = false
                        this.deviceData.TiltValue = 2
                        break;
                    default:
                        break;
                }
                this.$store.commit('setOneDeviceData', this.deviceData);
                this.$store.commit('deleteAlarmMessage', this.deviceData);
                this.$message({
                    type: 'success',
                    message: '警报解除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });

        },

        // 查看sim卡信息

        async openSim() {
            console.log(this.deviceData);
            const hignHex = this.deviceData.imsih.toString(16);
            const lowHex = this.deviceData.imsil.toString(16);
            let str = hignHex + lowHex;
            let strArr = str.split('');
            let twoArr = [];
            strArr.forEach((item, index) => {
                if (index == 0) {
                    return;
                }
                if (index % 2) {
                    twoArr.push(`${strArr[index - 1]}${strArr[index]}`);
                }
            });
            let resultStr = '';
            twoArr.forEach((item) => {
                item = parseInt(`0x${item}`, 16);
                if (item < 10) {
                    item = `0${item}`;
                }
                resultStr += item;
            });




            let imsi = resultStr.substring(0, resultStr.length - 1);
            console.log('imsi');
            console.log(imsi);
            const result = await QuerySim({
                imsi,
                apiKey: 'da7e3440791b282b834fb6afcdc7583038e338fd',
                sign: '907c5843331931ad7ea10d33407669eb'
            });
            // const result = await axios.get(`https://ec.upiot.net/api/v2/da7e3440791b282b834fb6afcdc7583038e338fd/card/${imsi}/?_sign=907c5843331931ad7ea10d33407669eb`);
            this.simShow = true;
            this.simData = result.data;
        },

        // 导出文件
        async exprotFile() {
            // 格式化为一个数组数组
            let jsonData = [];
            this.excData.xData.forEach((item, index) => {
                jsonData.push({ 时间: item });
            });
            this.excData.transformedData.forEach((item, index) => {
                item.data.forEach((element, ind) => {
                    let obj = jsonData[ind];
                    obj[item.name] = element.value;
                    jsonData[ind] = obj;
                });
            });
            console.log(jsonData, 'jsonData');

            // // 导出 Excel
            json2Excel(jsonData, `${new Date().getTime()}`, `${new Date().getTime()}.xlsx`);
        },
        // 导出报警数据
        async exprotFileAlarm() {
            // 格式化为一个数组数组
            let jsonData = [];
            this.excData2.forEach((item, index) => {
                jsonData.push({ 时间: item.time, 报警类型: item.type, 异常数据: item.sensorValue });
            });
            // this.excData.forEach((item, index) => {
            //     item.data.forEach((element, ind) => {
            //         let obj = jsonData[ind];
            //         obj[item.name] = element.value;
            //         jsonData[ind] = obj;
            //     });
            // });
            // // 导出 Excel
            console.log(this.excData2, 'this.excData2');
            console.log(jsonData, 'jsonData22222');
            json2Excel(jsonData, `${new Date().getTime()}`, `${new Date().getTime()}.xlsx`);
        },
        // 修改echarts类型 多属性或单属性
        changeEchartsType() {
            console.log('执行了');
            // 清除之前的echarts
            this.isMoreEcharts = !this.isMoreEcharts;
            // 判断当前是什么类型
            if (this.isMoreEcharts) {
                console.log('在这里');
                this.$nextTick(() => {
                    // this.echartsInitMore();
                    this.queryHistoryPropty(true);
                });
            } else {
                console.log('在下边');
                this.$nextTick(() => {
                    this.queryHistoryPropty(false);
                });
            }
        },
        // 查看设备图片
        showImg() {
            if (this.deviceData.imgSrc) {
                this.showImgPriver = true;
                return;
            }
            this.$message.warning('没有图片');
        },
        hidImgPriverFunc() {
            this.showImgPriver = false;
        },
        // 设置设备
        setting(e) {
            switch (e) {
                case 'anotherName':
                    break;

                default:
                    break;
            }
        },

        // 监听日期时间选择器
        handleDateTimeUpdated(datetime) {
            this.historySelectDate = datetime;
        },
        handleDateTimeUpdatedTwo(datetimeTwo) {
            this.alarmHistorySelectDate = datetimeTwo;
            console.log(this.alarmHistorySelectDate, 'this.alarmHistorySelectDate');
        },
        // 监听属性选择器
        selectChange(e) {
            this.selectDefaultValue = e;
        },
        // 历史属性查询
        async queryHistoryPropty(type, isClick) {
            // 判断是单属性还是多属性
            if (type) {
                // 多属性
                console.log('多属性查询');
                let startTime = null
                let endTime = null
                if (isClick) {
                    startTime = new Date(this.historySelectDate[0] + ' ' + '00:00:00').getTime();
                    endTime = new Date(this.historySelectDate[1] + ' ' + '23:59:59').getTime();
                } else {
                    startTime = new Date(this.historySelectDate[0]).getTime();
                    endTime = new Date(this.historySelectDate[1]).getTime();
                }

                const result = await QueryHistoryMoreProptyProject({
                    projectId: this.deviceData.projectId,
                    deviceName: this.deviceData.deviceName,
                    selectOption: JSON.stringify(this.selectOption),
                    startTime: startTime,
                    endTime: endTime
                });
                if (result.code !== 200) {
                    return;
                }
                if (result.data.length == 0) {
                    return this.$message.warning('未查询到历史数据');
                }
                // 获得历史属性值 处理数据
                this.historMoreDataHandle(result.data, this.deviceData);
                return;
            } else {
                // 单属性
                // 判断属性是否完整
                let startTime = new Date(this.historySelectDate[0]).getTime();
                let endTime = new Date(this.historySelectDate[1]).getTime();
                this.historyProptySearchTag = this.selectDefaultValue;
                const result = await QueryHistoryProptyProject({
                    projectId: this.deviceData.projectId,
                    deviceName: this.deviceData.deviceName,
                    historyProptySearchTag: this.historyProptySearchTag,
                    startTime: startTime,
                    endTime: endTime
                });
                if (result.code !== 200) {
                    return;
                }

                if (result.data.length == 0) {
                    return this.$message.warning('未查询到历史数据');
                }
                // 获得历史属性值 处理数据
                this.historDataHandle(result.data, this.deviceData, this.historyProptySearchTag);
                return;
            }
        },

        // 处理单图表历史属性数据
        historDataHandle(data, deviceData, tag) {
            let unitObj = [];
            switch (deviceData.deviceType) {
                case '智能井盖':

                    unitObj = [
                        { name: 'sinr', unit: 'db' },
                        { name: 'rssi', unit: 'dbm' },
                        { name: 'openStatus', unit: null },
                        { name: 'TiltValue', unit: '°' },
                        { name: 'light', unit: 'lux' },
                        { name: 'BatteryRemain', unit: 'V' },
                        { name: 'pci', unit: null },
                        { name: 'rsrp', unit: 'dbm' }
                    ];
                    break;
                case '智能井盖L3W':
                    unitObj = [
                        { name: 'sinr', unit: 'db' },
                        { name: 'rssi', unit: 'dbm' },
                        { name: 'openStatus', unit: null },
                        { name: 'TiltValue', unit: '°' },
                        { name: 'light', unit: 'lux' },
                        { name: 'BatteryRemain', unit: 'V' },
                        { name: 'pci', unit: null },
                        { name: 'rsrp', unit: 'dbm' }
                    ];
                    break;
                case '雨量监测':
                    unitObj = [
                        { name: 'momentRain', unit: 'mm' },
                        { name: 'todayRain', unit: 'mm' },
                        { name: 'yesterdayRain', unit: 'mm' },
                        { name: 'allRain', unit: 'mm' }
                    ];
                    break;
                case '水位流速监测':
                    unitObj = [
                        { name: 'flow', unit: 'm³/s' },
                        { name: 'level1', unit: 'm' },
                        { name: 'level2', unit: 'm' },
                        { name: 'section_speed', unit: 'm/s' },
                        { name: 'total_flow', unit: 'm³' }
                    ];
                    break;

                default:
                    break;
            }

            // 设置单位
            let unit = null;
            unitObj.forEach((item) => {
                if (item.name == tag) {
                    unit = item.unit;
                }
            });

            // 循环设置曲线图所需数据
            let xData = [];
            let yData = [];
            let yAxisType = 'value';
            if (tag == 'openStatus') {
                yAxisType = 'category';
            }
            data.forEach((item) => {
                xData.push(moment(item.createTime * 1).format('MM-DD HH:mm:ss'));

                // 判断是否开启状态
                if (this.historyProptySearchTag == 'openStatus') {
                    yData.push(item[this.historyProptySearchTag] ? '打开' : '关闭');
                } else {
                    yData.push(item[this.historyProptySearchTag] * 1);
                }
            });
            this.echatsInit(xData, yData, yAxisType, unit);
        },

        // 处理多图表历史属性数据
        historMoreDataHandle(data, deviceData) {
            console.log(data, 'data');
            let unitObj = [];
            switch (deviceData.deviceType) {
                case '智能井盖':
                    if (deviceData.projectId == 'SDlwV4') {
                        unitObj = [
                            { name: 'R', unit: 'dbm', label: '信号强度' },
                            { name: 'CS', unit: null, label: '开启状态' },
                            { name: 'TV', unit: '°', label: '井盖倾斜度' },
                            { name: 'BR', unit: 'V', label: '电池电压' },
                        ];
                    } else if (deviceData.projectId == 'SDbsjS') {
                        unitObj = [
                            { name: 'csqSignal', unit: 'dbm', label: '信号强度' },
                            { name: 'openStatus', unit: null, label: '开启状态' },
                            { name: 'TiltValue', unit: '°', label: '井盖倾斜度' },
                            { name: 'BatteryRemain', unit: 'V', label: '电池电压' },
                        ];
                    } else {

                        unitObj = [
                            { name: 'sinr', unit: 'db', label: '信号与干扰加噪声比' },
                            { name: 'rssi', unit: 'dbm', label: '信号强度' },
                            { name: 'openStatus', unit: null, label: '开启状态' },
                            { name: 'TiltValue', unit: '°', label: '井盖倾斜度' },
                            { name: 'light', unit: 'lux', label: '井内光照度' },
                            { name: 'BatteryRemain', unit: 'V', label: '电池电压' },
                            { name: 'rsrp', unit: 'dbm', label: '参考信号接收功率' }
                        ];
                    }
                    break;
                case '智能井盖L3W':
                    unitObj = [
                        { name: 'sinr', unit: 'db', label: '信号与干扰加噪声比' },
                        { name: 'rssi', unit: 'dbm', label: '信号强度' },
                        { name: 'openStatus', unit: null, label: '开启状态' },
                        { name: 'TiltValue', unit: '°', label: '井盖倾斜度' },
                        { name: 'light', unit: 'lux', label: '井内光照度' },
                        { name: 'BatteryRemain', unit: 'V', label: '电池电压' },
                        { name: 'rsrp', unit: 'dbm', label: '参考信号接收功率' }
                    ];
                    break;
                case '雨量监测':
                    unitObj = [
                        { name: 'momentRain', unit: 'mm', label: '瞬时雨量' },
                        { name: 'todayRain', unit: 'mm', label: '今日雨量' },
                        { name: 'yesterdayRain', unit: 'mm', label: '昨日雨量' },
                        { name: 'allRain', unit: 'mm', label: '累计雨量' }
                    ];
                    break;
                case '水位流速监测':
                    unitObj = [
                        { name: 'flow', unit: 'm³/s', label: '瞬时流量' },
                        { name: 'level1', unit: 'm', label: '管网水位' },
                        { name: 'level2', unit: 'm', label: '检查井通水位' },
                        { name: 'section_speed', unit: 'm/s', label: '断面流速' },
                        { name: 'total_flow', unit: 'm³', label: '累计流量' }
                    ];
                    break;
                case '积水监测':
                    unitObj = [
                        { name: 'waterLevel', unit: 'm', label: '水位' },
                        { name: 'signal', unit: 'db', label: '信号' },
                    ];
                    break;
                case '雷达水位计':
                    unitObj = [
                        { name: 'waterLevel', unit: 'm', label: '水位' },
                    ];
                    break;
                case '不锈钢井盖':
                    unitObj = [
                        { name: 'signal', unit: 'dbm', label: '信号强度' },
                        { name: 'openLock', unit: null, label: '锁机开启状态' },
                        { name: 'coverSta', unit: null, label: '井盖开启状态' },
                        { name: 'ADC0', unit: 'V', label: '电池电压' },
                    ];
                    break;
                case '智能井盖4G':
                    unitObj = [
                        { name: 'csqSignal', unit: 'dbm', label: '信号强度' },
                        { name: 'openStatus', unit: null, label: '开启状态' },
                        { name: 'TiltValue', unit: '°', label: '井盖倾斜度' },
                        { name: 'BatteryRemain', unit: 'V', label: '电池电压' },
                    ];
                    break;
                case '智能井盖V4':
                    unitObj = [
                        { name: 'R', unit: 'dbm', label: '信号强度' },
                        { name: 'CS', unit: null, label: '开启状态' },
                        { name: 'TV', unit: '°', label: '井盖倾斜度' },
                        { name: 'BR', unit: 'V', label: '电池电压' },
                    ];
                    break;
                case '水质监测':
                    if (deviceData.deviceNo == '03A0572AE0N7S40S' || deviceData.deviceNo == '74580F5E532252FK' || deviceData.deviceNo == '79A632Q1R5U20980' || deviceData.deviceNo == '74AP5916045Z8VSP' || deviceData.deviceNo == 'KEPF6F04B2E110HZ' || deviceData.deviceNo == '6VX5H9D513415CM5') {
                        unitObj = [

                            { name: 'phValue', unit: '*1', label: 'PH值' },
                            { name: 'phValue100', unit: '*100', label: 'PH值' },

                            { name: 'ecValue', unit: 'uS/cm', label: 'EC值' },
                            { name: 'sWaterValue', unit: 'm', label: '标准水位' },
                            { name: 'waterValue', unit: 'm', label: '测量水位' },
                        ];
                    } else {
                        unitObj = [
                            { name: 'phValue', unit: '*1', label: 'PH值' },
                            { name: 'phValue100', unit: '*100', label: 'PH值' },

                            { name: 'codValue', unit: 'mg/L', label: 'COD值' },
                            { name: 'ecValue', unit: 'uS/cm', label: 'EC值' },
                            { name: 'sWaterValue', unit: 'm', label: '标准水位' },
                            { name: 'waterValue', unit: 'm', label: '测量水位' },
                        ];
                    }

                    break;
                default:
                    break;
            }

            let transformedData = Object.keys(data[0]).reduce((acc, key) => {
                acc.push({
                    name: key,
                    // data: data.map((item) => item[key]),
                    data: data.map((item) => {
                        return {
                            value: item[key]
                        };
                    }),
                    type: 'line'
                });
                return acc;
            }, []);
            transformedData.splice(transformedData.length - 1, 1);

            let xData = [];
            data.forEach((item) => {
                xData.push(moment(item.createTime * 1).format('MM-DD HH:mm:ss'));
            });

            console.log(transformedData);
            transformedData.forEach((element, ind) => {
                unitObj.forEach((item, index) => {
                    if (element.name == item.name) {
                        // 设置searse
                        transformedData[ind].name = `${item.label}(${item.unit})`;
                    }
                });
            });

            let legendData = unitObj.map((item) => {
                return `${item.label}(${item.unit})`;
            });
            console.log(transformedData, 'transformedData');
            this.excData = { xData, legendData, transformedData };
            this.echartsInitMore(xData, legendData, transformedData);
        },

        // 获取单属性数据
        settingSelectOption() {
            switch (this.deviceData.deviceType) {
                case '智能井盖':
                    if (this.deviceData.projectId == 'SDlwV4') {
                        this.selectDefaultValue = 'R';
                        this.selectOption = [
                            {
                                label: '信号强度',
                                value: 'R'
                            },

                            {
                                label: '电池电压',
                                value: 'BR'
                            },

                            {
                                label: '井盖倾斜度',
                                value: 'TV'
                            },
                            {
                                label: '开启状态',
                                value: 'CS'
                            }
                        ];
                    } else if (this.deviceData.projectId == 'SDbsjS') {
                        this.selectDefaultValue = 'csqSignal';
                        this.selectOption = [
                            // {
                            //     label: '信号与干扰加噪声比',
                            //     value: 'sinr'
                            // },
                            // {
                            //     label: '参考信号接收功率',
                            //     value: 'rsrp'
                            // },
                            {
                                label: '信号强度',
                                // value: 'rssi'
                                value: 'csqSignal'
                            },
                            // {
                            //     label: '物理小区标识',
                            //     value: 'pci'
                            // },
                            {
                                label: '电池电压',
                                value: 'BatteryRemain'
                            },
                            // {
                            //     label: '井内光照度',
                            //     value: 'light'
                            // },
                            {
                                label: '井盖倾斜度',
                                value: 'TiltValue'
                            },
                            {
                                label: '开启状态',
                                value: 'openStatus'
                            }
                        ];
                    } else {
                        this.selectDefaultValue = 'sinr';
                        this.selectOption = [
                            {
                                label: '信号与干扰加噪声比',
                                value: 'sinr'
                            },
                            {
                                label: '参考信号接收功率',
                                value: 'rsrp'
                            },
                            {
                                label: '信号强度',
                                value: 'rssi'
                            },
                            {
                                label: '电池电压',
                                value: 'BatteryRemain'
                            },
                            {
                                label: '井内光照度',
                                value: 'light'
                            },
                            {
                                label: '井盖倾斜度',
                                value: 'TiltValue'
                            },
                            {
                                label: '开启状态',
                                value: 'openStatus'
                            }
                        ];
                    }


                    break;
                case '智能井盖L3W':
                    this.selectDefaultValue = 'sinr';
                    this.selectOption = [
                        {
                            label: '信号与干扰加噪声比',
                            value: 'sinr'
                        },
                        {
                            label: '参考信号接收功率',
                            value: 'rsrp'
                        },
                        {
                            label: '信号强度',
                            value: 'rssi'
                        },

                        {
                            label: '电池电压',
                            value: 'BatteryRemain'
                        },
                        {
                            label: '井内光照度',
                            value: 'light'
                        },
                        {
                            label: '井盖倾斜度',
                            value: 'TiltValue'
                        },
                        {
                            label: '开启状态',
                            value: 'openStatus'
                        }
                    ];
                    break;
                case '水位流速监测':
                    this.selectDefaultValue = 'flow';
                    this.selectOption = [
                        {
                            label: '瞬时流量',
                            value: 'flow'
                        },
                        {
                            label: '管网水位',
                            value: 'level1'
                        },
                        {
                            label: '检查井筒水位',
                            value: 'level2'
                        },
                        {
                            label: '断面流速',
                            value: 'section_speed'
                        },
                        {
                            label: '累计流量',
                            value: 'total_flow'
                        }
                    ];
                    break;
                case '雨量监测':
                    this.selectDefaultValue = 'momentRain';
                    this.selectOption = [
                        {
                            label: '累计雨量',
                            value: 'allRain'
                        },
                        {
                            label: '昨日雨量',
                            value: 'yesterdayRain'
                        },
                        {
                            label: '今日雨量',
                            value: 'todayRain'
                        },
                        {
                            label: '瞬时雨量',
                            value: 'momentRain'
                        }
                    ];
                    break;
                case '智能井盖4G':
                    this.selectDefaultValue = 'csqSignal';
                    this.selectOption = [
                        // {
                        //     label: '信号与干扰加噪声比',
                        //     value: 'sinr'
                        // },
                        // {
                        //     label: '参考信号接收功率',
                        //     value: 'rsrp'
                        // },
                        {
                            label: '信号强度',
                            // value: 'rssi'
                            value: 'csqSignal'
                        },
                        // {
                        //     label: '物理小区标识',
                        //     value: 'pci'
                        // },
                        {
                            label: '电池电压',
                            value: 'BatteryRemain'
                        },
                        // {
                        //     label: '井内光照度',
                        //     value: 'light'
                        // },
                        {
                            label: '井盖倾斜度',
                            value: 'TiltValue'
                        },
                        {
                            label: '开启状态',
                            value: 'openStatus'
                        }
                    ];
                    break;
                case '智能井盖V4':
                    this.selectDefaultValue = 'R';
                    this.selectOption = [
                        {
                            label: '信号强度',
                            value: 'R'
                        },

                        {
                            label: '电池电压',
                            value: 'BR'
                        },

                        {
                            label: '井盖倾斜度',
                            value: 'TV'
                        },
                        {
                            label: '开启状态',
                            value: 'CS'
                        }
                    ];
                    break;
                case '积水监测':
                    this.selectDefaultValue = 'waterLevel';
                    if (this.deviceData.projectId == 'SDjsjc') {
                        this.selectOption = [
                            {
                                label: '水位',
                                value: 'waterLevel'
                            }
                        ];
                    } else {
                        this.selectOption = [
                            {
                                label: '信号强度',
                                value: 'signal'
                            },
                            {
                                label: '水位',
                                value: 'waterLevel'
                            }
                        ];
                    }

                    break;
                case '雷达水位计':
                    this.selectDefaultValue = 'waterLevel';
                    this.selectOption = [
                        {
                            label: '水位',
                            value: 'waterLevel'
                        }
                    ];

                    break;
                case '不锈钢井盖':
                    this.selectDefaultValue = 'openLock';
                    this.selectOption = [
                        {
                            label: '锁机状态',
                            value: 'openLock'
                        }, {
                            label: '信号强度',
                            value: 'signal'
                        }, {
                            label: '电池电压',
                            value: 'ADC0'
                        }, {
                            label: '井盖状态',
                            value: 'coverSta'
                        }
                    ]
                    break;
                case '水质监测':
                    this.selectDefaultValue = 'sWaterValue';
                    if (this.deviceData.deviceNo == '03A0572AE0N7S40S' || this.deviceData.deviceNo == '74580F5E532252FK' || this.deviceData.deviceNo == '79A632Q1R5U20980' || this.deviceData.deviceNo == '74AP5916045Z8VSP' || this.deviceData.deviceNo == 'KEPF6F04B2E110HZ' || this.deviceData.deviceNo == '6VX5H9D513415CM5') {
                        this.selectOption = [
                            {
                                label: '标准水位',
                                value: 'sWaterValue'
                            },
                            {
                                label: '测量水位',
                                value: 'waterValue'
                            },
                            {
                                label: 'EC值',
                                value: 'ecValue'
                            },

                            {
                                label: 'PH值',
                                value: 'phValue'
                            }
                        ];
                    } else {
                        this.selectOption = [
                            {
                                label: '标准水位',
                                value: 'sWaterValue'
                            },
                            {
                                label: '测量水位',
                                value: 'waterValue'
                            },
                            {
                                label: 'EC值',
                                value: 'ecValue'
                            },
                            {
                                label: 'COD值',
                                value: 'codValue'
                            },
                            {
                                label: 'PH值',
                                value: 'phValue'
                            }
                        ];
                    }


                    break;
                default:
                    break;
            }
        },

        // 单属性图表
        echatsInit(xData, yData, yAxisType, unit) {
            if (this.echartsDom) {
                this.echartsDom.dispose();
            }
            this.echartsDom = this.$echarts.init(this.$refs.canva7);
            this.echartsDom.setOption({
                grid: {
                    left: 20,
                    top: 10,
                    right: 20,
                    bottom: 0,
                    containLabel: true
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                xAxis: {
                    type: 'category',
                    data: xData,
                    axisLabel: {
                        color: '#fff'
                    },
                    boundaryGap: false
                },
                yAxis: {
                    type: yAxisType,
                    axisLabel: {
                        color: '#fff'
                    },
                    name: `单位: ${unit ? unit : '无'}`
                },
                series: [
                    {
                        data: yData,
                        type: 'line',
                        lineStyle: {
                            width: 0
                        },
                        showSymbol: false,
                        areaStyle: {
                            opacity: 0.8,
                            color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 1,
                                    color: 'rgb(0, 221, 255)'
                                },
                                {
                                    offset: 0,
                                    color: 'rgb(77, 119, 255)'
                                }
                            ])
                        }
                    }
                ]
            });
        },
        // 多属性图表
        echartsInitMore(xData, legendData, data) {
            if (this.echartsDom) {
                this.echartsDom.dispose();
            }
            this.echartsDom = this.$echarts.init(this.$refs.canva8);
            this.echartsDom.setOption({
                grid: {
                    left: 0,
                    top: 50,
                    right: 10,
                    bottom: 0,
                    containLabel: true
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                xAxis: {
                    type: 'category',
                    data: xData,
                    axisLabel: {
                        color: '#fff'
                    },
                    boundaryGap: false
                },
                legend: {
                    data: legendData,
                    textStyle: {
                        color: '#fff',
                        fontWeight: 'bold'
                    },
                    pageIconColor: '#fff',
                    pageTextStyle: {
                        color: '#fff'
                    },
                    itemWidth: 20, // 标签宽度为20px
                    itemHeight: 20, // 标签高度为10px
                    type: 'scroll'
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        color: '#fff'
                    }
                },
                series: data
            });
        },
        close() {
            this.$emit('close');
        }
    }
};
</script>



<style scoped lang="less">
/deep/ .box {
    top: 5vh;
    transform: translateX(-50%);
    height: 90vh;
    max-height: calc(100vh - 10vh);
}

/deep/ .box .close {
    top: 8px;
    right: 8px;
}

.content {


    .list {
        border-bottom: 1px solid #14283e;
        padding: 10px 0;

        .titleBox {
            display: flex;
            align-items: center;

            .closeAlarmBox {
                display: flex;
                align-items: center;
                margin-left: 10px;
                background-color: #000;
                box-sizing: border-box;
                color: #fff;
                transition: all 0.5s;
                font-size: 12px;
                margin-bottom: 8px;

                padding: 3px 7px;
            }

            .closeAlarmBox:hover {
                background-color: #fff;
                color: #000;
                cursor: pointer;
            }
        }

        .title {
            color: #fff;
            font-weight: bold;
            letter-spacing: 2px;
            font-size: 17px;
            padding-left: 5px;
            margin-bottom: 10px;
            box-sizing: border-box;
            border-left: 5px solid #06ffb4;
        }

        .proptyTitleBox {
            display: flex;
            align-items: center;

            .menu {
                margin-left: 10px;
                background-color: #000;
                box-sizing: border-box;
                color: #fff;
                transition: all 0.5s;
                font-size: 14px;
                padding: 2px 5px;

                .iconfont {
                    font-size: 14px;
                    padding-left: 3px;
                }
            }

            .menu:hover {
                background-color: #fff;
                color: #000;
                cursor: pointer;
            }
        }

        table {
            border-collapse: collapse;
            width: 100%;
            font-size: 14px;
            color: #fff;
        }

        td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
        }

        .point {
            cursor: pointer;
            // transition: all 0.5s;
        }


        .even-row {
            background-color: #06b6ff;
            font-weight: bold;
            text-align: center;

            td {
                white-space: nowrap;
            }

        }

        .echatsMenu {
            display: flex;
            align-items: center;
            justify-content: right;

            .propt {
                width: max-content;
            }

            .date {
                width: max-content;
            }

            .queryBtn {
                padding: 5px;
                background-color: #fff;
                color: #000;
                box-sizing: border-box;
                font-size: 12px;
                display: flex;
                align-items: center;
                height: 30px;
                margin-left: 10px;
                margin-right: 10px;
                transition: all 0.5s;
                cursor: pointer;
            }
        }

        .echart {
            width: 100%;
            height: 300px;
        }
    }

    .history {
        display: flex;
        justify-content: start;

        .menu {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 10px;
            background-color: #000;
            box-sizing: border-box;
            color: #fff;
            transition: all 0.5s;
            font-size: 14px;
            height: 20px;
            padding: 4px;
            margin-top: 2px;

            .iconfont {
                font-size: 14px;
                padding-left: 3px;
            }
        }

        .menu:hover {
            background-color: #fff;
            color: #000;
            cursor: pointer;
        }
    }
}
</style>


<style lang="less" scoped>
/deep/ .el-table {
    margin-top: 10px;
}

/deep/ .el-table th {
    background-color: #06b6ff !important;
    color: #fff;
}

/deep/ .el-table td {
    background-color: rgba(0, 0, 0, 1) !important;
    color: #fff;
}
</style>
